import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import PriceTable from "../components/PriceTable";
import CustomerForm from "../components/Customer";
import Address from '../components/Address';
import CropImage from "../components/cropImage";
import { Link } from "react-router-dom";
import { API_BASE_URL, Image_URL } from "../config";


const PartnerAccount = () => {
  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState("login-security");
  //const [showAddressForm, setShowAddressForm] = useState(false);
  //const [isEditing, setIsEditing] = useState(false); 
  const [editField, setEditField] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [addressList, setAddressList] = useState([]);


  const [formData, setFormData] = useState({
    mobile: "",
    password: "",
    compensation:"",
    logoPreview: null,
    logoFile: null,
  });

  useEffect(() => {

    const storedUser = localStorage.getItem("user");

    if (storedUser) {
      setUser(JSON.parse(storedUser));
    } else {
      setUser({ addresses: [] }); // Ensure user is set but addresses are empty
    }
  }, []);
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUser(parsedUser);
      setFormData({
        mobile: parsedUser.mobile || "",
        password: parsedUser.password || "",
        compensation:parsedUser.compensation || "",
        logoPreview: null,
        logoFile: null,
      });
    } else {
      setUser({ addresses: [] });
    }
  }, []);


  const handleSave = async (field) => {
    try {
      const updatedCompany = {
        Id: user?.companyId,
        Mobile: formData.mobile,
        Password: formData.password,
        BusinessCompensation: formData.compensation,
        CreatedBy: "Customer",
        companyLogo: formData.logoFile ? formData.logoFile.name : user?.companyLogo,
      };

      const formDataObj = new FormData();
      formDataObj.append("modelJson", JSON.stringify(updatedCompany));

      if (field === "logo" && formData.logoFile) {
        formDataObj.append("Logo", formData.logoFile);
      }

      const response = await fetch(`${API_BASE_URL}/Home/UpdateCompany`, {
        method: "POST",
        body: formDataObj,
      });

      const result = await response.json();
      if (response.ok) {


        const updatedUser = {
          ...user,
          mobile: formData.mobile,
          password: formData.password,
          companyLogo: result.data.companyLogo || user.companyLogo,
        };

        setUser(updatedUser);
        localStorage.setItem("user", JSON.stringify(updatedUser));

        alert("Updated Successfully!");
        setEditField(null);
        window.location.reload();
      } else {
        alert("Update failed: " + result.message);
      }
    } catch (err) {
      console.error("Update error", err);
      alert("Something went wrong");
    }
  };

  return (
    <>
      <div className="home">
        <div id="page" className="hfeed page-wrapper">
          <Header />
          <div id="site-main" className="site-main">
            <div id="main-content" className="main-content">
              <div id="primary" className="content-area">

                <div id="content" className="site-content" role="main">
                  <div className="section-padding">
                    <div className="section-container p-l-r">
                      <div className="tab-container">
                        <h2 className="text-center"> <Link to="/partnerdashboard" style={{ color: "black" }} className="btn btn-view"> <i className="fa fa-arrow-left" aria-hidden="true"></i></Link> My Profile</h2>

                        {/* Tab Headers */}
                        <div className="tab-header">
                          <button
                            className={`tab-btn ${activeTab === "login-security" ? "active" : ""}`}
                            onClick={() => setActiveTab("login-security")}
                          >
                            Login and Security
                          </button>
                          <button
                            className={`tab-btn ${activeTab === "address" ? "active" : ""}`}
                            onClick={() => setActiveTab("address")}
                          >
                            Address
                          </button>
                          {user && user.userType === "Company" && (
                            <>
                          <button
                            className={`tab-btn ${activeTab === "PriceBrackets" ? "active" : ""}`}
                            onClick={() => setActiveTab("PriceBrackets")}
                          >
                            Price Brackets
                          </button>
                          {/* <button
                            className={`tab-btn ${activeTab === "CustomPriceBrackets" ? "active" : ""}`}
                            onClick={() => setActiveTab("CustomPriceBrackets")}
                          >
                            Customer Mark Up Price
                          </button> */}
                          
                            <button
                              className={`tab-btn ${activeTab === "CustomerReg" ? "active" : ""}`}
                              onClick={() => setActiveTab("CustomerReg")}
                            >
                              Create User
                            </button>
                            </>
                          )}

                        </div>

                        {/* Login & Security Tab */}
                        {activeTab === "login-security" && (
                          <div className="tab-content active" id="login-security">
                            <div className="login-security-box">

                              {/* Name - view only */}
                              <div className="login-info">
                                <div>
                                  Name <br />
                                  {user ? user.companyName : "Loading..."}
                                </div>
                              </div>
                              <hr />

                              {/* Email - view only */}
                              <div className="login-info">
                                <div>
                                  Email <br />
                                  {user ? user.email : "Loading..."}
                                </div>
                              </div>
                              <hr />

                              {/* Mobile - editable */}
                              <div className="login-info">
                                <div>
                                  Primary mobile number <br />
                                  {editField === "mobile" ? (
                                    <input
                                      type="number"
                                      maxLength={15}
                                      value={formData.mobile}
                                      onChange={(e) =>
                                        setFormData({ ...formData, mobile: e.target.value })
                                      }
                                    />
                                  ) : (
                                    user?.mobile || "Loading..."
                                  )}
                                </div>
                                <button
                                  className="login-info-btn"
                                  onClick={() => {
                                    if (editField === "mobile") {
                                      handleSave("mobile");
                                    } else {
                                      setEditField("mobile");
                                    }
                                  }}
                                >
                                  {editField === "mobile" ? "Save" : "Edit"}
                                </button>
                              </div>
                              <hr />

                              {/* Password - editable */}
                              <div className="login-info">
                                <div>
                                  Password <br />
                                  {editField === "password" ? (
                                    <>
                                      <input
                                        type={showPassword ? "text" : "password"}
                                        value={formData.password}
                                        onChange={(e) =>
                                          setFormData({ ...formData, password: e.target.value })
                                        }
                                      />
                                      <button
                                        type="button"
                                        className="show-hide-btn"
                                        onClick={() => setShowPassword(!showPassword)}
                                      >
                                        {showPassword ? "Hide" : "Show"}
                                      </button>
                                    </>
                                  ) : (
                                    "******"
                                  )}
                                </div>
                                <button
                                  className="login-info-btn"
                                  onClick={() => {
                                    if (editField === "password") {
                                      handleSave("password");
                                    } else {
                                      setEditField("password");
                                      setShowPassword(true); // 👈 Show password when clicking "Edit"
                                    }
                                  }}
                                >
                                  {editField === "password" ? "Save" : "Edit"}
                                </button>
                              </div>
                              <hr />
                              <div className="login-info">
                                <div>
                                  Upload Logo only jpg and png (170px and 59px) <br />
                                  {editField === "logo" ? (
                                    <>
                                      <CropImage
                                        aspectRatio={170 / 59} // Aspect ratio for 170x59
                                        targetWidth={170}
                                        targetHeight={59}
                                        onImageCropped={(croppedFile, previewUrl) => {
                                          setFormData({ ...formData, logoFile: croppedFile, logoPreview: previewUrl });
                                        }}
                                      />
                                      {formData.logoPreview && (
                                        <div style={{ marginTop: '10px' }}>
                                          <img
                                            src={formData.logoPreview}
                                            alt="Cropped Preview"
                                            width="170"
                                            height="59"
                                            style={{ objectFit: 'contain', border: '1px solid #ccc' }}
                                          />
                                        </div>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {user?.companyLogo ? (
                                        <div style={{ marginTop: '10px' }}>
                                          <img
                                            src={`${Image_URL}/Companylogo/${user.companyLogo}`}
                                            alt="Company Logo"
                                            width="170"
                                            height="59"
                                            style={{ objectFit: 'contain', border: '1px solid #ccc' }}
                                          />
                                        </div>
                                      ) : (
                                        "No logo uploaded"
                                      )}
                                    </>
                                  )}
                                </div>
                                <button
                                  className="login-info-btn"
                                  onClick={() => {
                                    if (editField === "logo") {
                                      handleSave("logo");
                                    } else {
                                      setEditField("logo");
                                    }
                                  }}
                                >
                                  {editField === "logo" ? "Save" : "Edit"}
                                </button>
                              </div>

                            </div>
                          </div>
                        )}


                        {/* Address Tab */}
                        {activeTab === "address" && (
                          <div className="content-register">
                            <Address
                              userId={user.userId}
                              companyId={user.companyId}
                              onAddressesFetched={(fetchedAddresses) => {
                                setAddressList(fetchedAddresses);
                              }}
                            />

                          </div>
                        )}


                        {activeTab === "PriceBrackets" && (
                          <div className="tab-content" id="PriceBrackets">
                            <PriceTable />
                          </div>
                        )}
                        {/* {activeTab === "CustomPriceBrackets" && (
                          <div className="tab-content" id="CustomPriceBrackets">
                         <div className="login-info">
                                <div>
                                  Customer Markup % <br />
                                  {editField === "compensation" ? (
                                    <input
                                      type="text"
                                      maxLength={15}
                                      value={formData.compensation}
                                      onChange={(e) =>
                                        setFormData({ ...formData, compensation: e.target.value })
                                      }
                                    />
                                  ) : (
                                    user?.compensation || "Loading..."
                                  )}
                                </div>
                                <button
                                  className="login-info-btn"
                                  onClick={() => {
                                    if (editField === "compensation") {
                                      handleSave("compensation");
                                    } else {
                                      setEditField("compensation");
                                    }
                                  }}
                                >
                                  {editField === "compensation" ? "Save" : "Edit"}
                                </button>
                              </div>
                          </div>
                        )} */}

                        {activeTab === "CustomerReg" && (
                          <div className="tab-content" id="CustomerReg">
                            <CustomerForm />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </div>

          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default PartnerAccount;
